export default {
	empty: {
		body: 'We weren’t able to find any results for this make and model. Please try again with a different search.',
		buttonText: 'Return to Insights home',
	},
	error: {
		body: 'There’s been a minor technical issue. Please refresh the page. If the problem persists, contact your Account Manager or Dealer Support.',
		buttonText: 'Refresh page',
	},
	heading1: 'Unable to display insights',
};
